import { render, staticRenderFns } from "./StockDepartmentSelector.vue?vue&type=template&id=4da9b9d6&scoped=true&"
import script from "./StockDepartmentSelector.vue?vue&type=script&lang=ts&"
export * from "./StockDepartmentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./StockDepartmentSelector.vue?vue&type=style&index=0&id=4da9b9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9b9d6",
  null
  
)

export default component.exports